// The admin launch endpoints (TOM-120, ADR 0248; specs/api_contracts.md §11.5
// "Launching a run on the worker"), beside evalsApi in adminApi.ts: the launch
// form's options, the estimate, the launch, a run's progress and its cancel,
// and a stored run's re-grade with its estimate (TOM-257, ADR 0254).

import { adminApi } from '../adminApi';
import type {
  EvalCancelOutcome,
  EvalLaunchEstimate,
  EvalLaunchOptions,
  EvalLaunchOutcome,
  EvalLaunchRequest,
} from './launch';
import type { EvalRunProgress } from './progress';
import type { EvalRegradeEstimate, EvalRegradeOutcome, EvalRegradeRequest } from './regrade';

const runPath = (id: string) => `/v1/admin/evals/runs/${encodeURIComponent(id)}`;

export const evalLaunchApi = {
  options(): Promise<EvalLaunchOptions> {
    return adminApi<EvalLaunchOptions>('/v1/admin/evals/launch-options');
  },
  /** The plan and its estimated cost, with what would refuse it. Writes nothing. */
  estimate(body: EvalLaunchRequest): Promise<EvalLaunchEstimate> {
    return adminApi<EvalLaunchEstimate>('/v1/admin/evals/estimate', { method: 'POST', body });
  },
  /** Launch: the run, its shards and their jobs, audited. Spends provider money. */
  launch(body: EvalLaunchRequest): Promise<EvalLaunchOutcome> {
    return adminApi<EvalLaunchOutcome>('/v1/admin/evals/runs', { method: 'POST', body });
  },
  progress(id: string): Promise<EvalRunProgress> {
    return adminApi<EvalRunProgress>(`${runPath(id)}/progress`);
  },
  /** Cancel between cases, audited. */
  cancel(id: string): Promise<EvalCancelOutcome> {
    return adminApi<EvalCancelOutcome>(`${runPath(id)}/cancel`, { method: 'POST', body: {} });
  },
  /** A re-grade's plan and its estimated cost (TOM-257), with what would refuse it. Writes nothing. */
  regradeEstimate(id: string, body: EvalRegradeRequest): Promise<EvalRegradeEstimate> {
    return adminApi<EvalRegradeEstimate>(`${runPath(id)}/regrade/estimate`, {
      method: 'POST',
      body,
    });
  },
  /** Re-grade a stored run on the worker (TOM-257), audited. Spends provider money. */
  regrade(id: string, body: EvalRegradeRequest): Promise<EvalRegradeOutcome> {
    return adminApi<EvalRegradeOutcome>(`${runPath(id)}/regrade`, { method: 'POST', body });
  },
};
